import React from 'react';
import classNames from 'classnames';
import inputArrow from '../../assets/images/input-arrow.svg';
import './CustomNumberInput.scss';

const CustomNumberInput = ({ value, onChange, min = 0, max = 100, onBlur, className }) => {
	const handleIncrement = () => {
		if (value < max) {
			onChange(value + 1);
		}
	};

	const handleDecrement = () => {
		if (value > min) {
			onChange(value - 1);
		}
	};

	const handleChange = (e) => {
		const parsedValue = parseInt(e.target.value, 10);
		const isValidNumber = !Number.isNaN(parsedValue) && parsedValue >= min && parsedValue <= max;
		if (!e.target.value) {
			onChange('');
		} else if (isValidNumber) {
			onChange(parsedValue);
		} else {
			onChange(Number.isNaN(parsedValue) || parsedValue < min ? min : value);
		}
	};

	return (
		<div className="custom-number-wrapper">
			<input onBlur={onBlur} value={value} onChange={handleChange} className={classNames('number-input', className)} />
			<div className="button-group">
				<button type="button" onClick={handleIncrement} disabled={value >= max} className="btn-increment">
					<img alt="increment" src={inputArrow} />
				</button>
				<button type="button" onClick={handleDecrement} disabled={value <= min} className="btn-decrement">
					<img alt="decrement" src={inputArrow} />
				</button>
			</div>
		</div>
	);
};

export default CustomNumberInput;
